module.exports = __webpack_public_path__ + "7bb435d6b4dc0d777cc1e5fd1245bdfe.png";